import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StaticImage from 'components/IndexPage/StaticImage';

import styles from './ScreensCarousel.scss';

const SCREEN_HEIGHT = 477;
export default function ScreensCarousel(props) {
  const { current, className } = props;
  const calcMarginForPosition = position => {
    const multiplier = position - current;
    return { top: multiplier * SCREEN_HEIGHT };
  };

  return (
    <div className={classnames(styles.wrapper, className)}>
      <div className={styles.container}>
        <StaticImage
          className={styles.screen}
          image="carousel_first"
          alt=""
          style={calcMarginForPosition(0)}
        />
        <StaticImage
          className={styles.screen}
          image="carousel_second"
          alt=""
          style={calcMarginForPosition(1)}
        />
        <StaticImage
          className={styles.screen}
          image="carousel_third"
          alt=""
          style={calcMarginForPosition(2)}
        />
        <StaticImage
          className={styles.screen}
          image="carousel_fourth"
          alt=""
          style={calcMarginForPosition(3)}
        />
      </div>
      <picture>
        <source
          type="image/webp"
          className={styles.layout}
          srcSet={'static/images/screens_carousel_layout.webp'}
          alt="screen_layout"
        />
        <img
          className={styles.layout}
          src={'static/images/screens_carousel_layout.png'}
          alt="screen_layout"
        />
      </picture>
    </div>
  );
}

ScreensCarousel.propTypes = {
  current: PropTypes.number,
  className: PropTypes.string,
};

ScreensCarousel.defaultProps = {
  current: 0,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/IndexPage/ScreensCarousel.jsx